import React from "react";
import classes from "./LessonDetail.module.css";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import ModalSkeletonClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import { Button } from "../../../../../stories/Button/Button";
import {
  CalendarIconGray,
  CancelIconBlack,
  ClockIconGray,
  coachDemoImg,
  LocationIconGray,
  ChatBlackIcon,
  FlagIconBlack,
} from "../../../../../constant/imagePath";
import moment from "moment";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";

const MessageLessonDetails = ({ show, setShow, data }) => {
  console.log(data);
  return (
    <>
      <style>{`
      .modal .modal-dialog {
        width: 328px;
      }
            @media screen and (max-width: 425px) {
          .modal .modal-dialog {
            width: 95% !important;
            margin: 0px auto;

          }
          }
          .${ModalSkeletonClasses.header}{
            margin:24px;
          }
          .modal-body{
            padding:0 24px 8px 24px;
          }

    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "0px", margin: "0px" }}
        width={"570px"}
        header={
          <h4
            className={classes.heading}
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Lesson details
          </h4>
        }
      >
        <div className={classes.modalContent}>
          <div className={[classes.middleSectionTitleDiv]}>
            <div className={[classes.imgDiv]}>
              <img src={data?.user?.profile} alt="..." />
            </div>
            <div className={[classes.titleContent]}>
              <h6 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h6 }}>
                {`${data?.type} ${data?.title}`}
              </h6>
            </div>
          </div>
          <div className={[classes.detailDiv]}>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={CalendarIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.eventDate}
              </span>
            </div>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={ClockIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.start}
                {"-"}
                {data?.end}
              </span>
            </div>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={LocationIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                className={[classes.locationSpan]}
              >
                income {data?.location}
              </span>
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

MessageLessonDetails.propTypes = {
  data: PropTypes.object,
};

MessageLessonDetails.defaultProps = {
  data: {
    start: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format("LT"),
    end: moment(moment().add(3, "hours").format()).add(0, "days").format("LT"),
    type: "1-on-1",
    id: 1,
    title: "Tennis Lesson with Jenny",
    eventDate: moment().add(0, "days").format("MMM DD, YYYY"),
    location: "Green Tennis Court",
    user: {
      profile: coachDemoImg,
    },
  },
};

export default MessageLessonDetails;
